import React, { useEffect, useState } from "react";
import {
  createTTSColor,
  getTTSColor,
  initTTSColor,
  removeTTSColor,
  updateTTSColor,
} from "src/apis/TTS/color.api";
import { useGetPermissionAccessControl } from "src/context/PermissionAccessControl";
import useControlPanel from "src/hooks/useControlPanel";
import useDebounce from "src/hooks/useDebounce";
import { isOpenPopup } from "../../utils";
import { NotifyConfirm } from "src/components/notify/Notify";
import TTSColorPopup from "../../components/Popup/TTSColorPopup";
import TTSColorControlPanel from "../../components/ControlPanel/TTSColorControlPanel";
import ControlPanelSystem from "src/components/controlPanelSystem/ControlPanelSystem";
import TTSColorTable from "../../components/Table/TTSColorTable";
import { path } from "src/constants/path";
import Pagination from "src/components/Pagination/Pagination";

const initColorData = {
  list: [],
  total_record: 1,
};

const titlePage = "TTS Color";

const TTSColor = () => {
  const permissionsAccessControl = useGetPermissionAccessControl();

  const {
    page,
    searchKey,
    numberPage,
    setNumberPage,
    limit,
    setLimit,
    status,
    setStatus,
    startDate,
    setStartDate,
    endDate,
    setEndDate,
    handleInputChange,
    handleChangePage,
  } = useControlPanel();

  const [colorData, setColorData] = useState(initColorData);
  const [filterColors, setFilterColors] = useState([]);

  const [recordForEdit, setRecordForEdit] = useState(null);
  const [openPopup, setOpenPopup] = useState(false);

  const [errorsForm, setErrorsForm] = useState({});
  const [loading, setLoading] = useState(true);

  let search = useDebounce(searchKey, 500);

  useEffect(() => {
    setLoading(true);

    const query = {
      page: numberPage,
      limit,
      searchKey: search,
      startDate,
      endDate,
      status,
    };

    getTTSColor(query, (result) => {
      setColorData({ ...result });
      setFilterColors([...result.list]);
      setLoading(false);
    });
  }, [endDate, limit, numberPage, search, startDate, status]);

  useEffect(() => {
    setNumberPage(page);
  }, [page, setNumberPage, status]);

  const showButtonInitColor = (page, searchKey, totalRecord) => {
    if (loading) {
      return false;
    }
    if (page === 1 && searchKey === "" && totalRecord === 0) {
      return true;
    }
    return false;
  };

  const actionAfterCreateOrUpdate = (result, resetForm) => {
    if (result.data?.status === 422) {
      setErrorsForm({ ...result.data.data });
    } else {
      getTTSColor({}, (result) => {
        setColorData({ ...result });
        setFilterColors([...result.list]);
        setLoading(false);
      });
      resetForm();
      handleOpenPopup(!isOpenPopup, null);
    }
  };

  const addOrEdit = (color, resetForm) => {
    if (!color.id) {
      createTTSColor(color, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    } else {
      updateTTSColor(color.id, color, (result) => {
        actionAfterCreateOrUpdate(result, resetForm);
      });
    }
  };

  const handleDelete = (colorDeleted) => {
    NotifyConfirm("warning", "Are you delete it ?", (result) => {
      if (result.isConfirmed) {
        const foundColorIndex = colorData.list.findIndex(
          (color) => color.id === colorDeleted.id
        );
        if (foundColorIndex !== -1) {
          removeTTSColor(colorDeleted.id);
          colorData.list.splice(foundColorIndex, 1);
          setColorData((prev) => {
            return {
              ...prev,
              list: [...colorData.list],
              total_record: prev.total_record - 1,
            };
          });
          setFilterColors([...colorData.list]);
        }
      }
    });
  };

  const handleOpenPopup = (isOpen, item) => {
    setOpenPopup(isOpen);
    setRecordForEdit(item);
    setErrorsForm({});
  };

  const initColor = () => {
    initTTSColor((result) => {
      if (result.data?.status === 422) {
        setErrorsForm({ ...result.data.data });
      } else {
        getTTSColor({}, (result) => {
          setColorData({ ...result });
          setFilterColors([...result.list]);
        });
      }
    });
  };

  return (
    <div>
      <div className="page-header">
        <h2>{titlePage}</h2>
      </div>

      <TTSColorPopup
        recordForEdit={recordForEdit}
        openPopup={openPopup}
        setOpenPopup={setOpenPopup}
        addOrEdit={addOrEdit}
        errorsForm={errorsForm}
      />

      <TTSColorControlPanel
        permissionsAccessControl={permissionsAccessControl}
        handleOpenPopup={handleOpenPopup}
        initColor={initColor}
        isShowButtonInit={showButtonInitColor(
          page,
          searchKey,
          colorData.total_record
        )}
      >
        <ControlPanelSystem
          searchKey={searchKey}
          handleInputChange={(e) => handleInputChange(e)}
          limit={limit}
          setLimit={setLimit}
          setNumberPage={setNumberPage}
          status={status}
          setStatus={setStatus}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />
      </TTSColorControlPanel>

      <TTSColorTable
        permissionsAccessControl={permissionsAccessControl}
        data={filterColors}
        handleOpenPopup={handleOpenPopup}
        handleDelete={handleDelete}
        status={status}
      />

      <Pagination
        pathname={path.ttsColor}
        page={numberPage}
        handleChangePage={(page) => handleChangePage(page)}
        limit={limit}
        pageSize={colorData.total_record}
      />
    </div>
  );
};

export default TTSColor;
